import {Component, EventEmitter, Input, Output} from "@angular/core";
import {BaseError} from "../../../../../../base-error";

@Component({
    selector: "transform-field-operator",
    templateUrl: "./transform-field-operator.component.html",
})

export class TransformFieldOperatorComponent extends BaseError {
    @Input() public transformationProps: object = {};
    @Output() public onCancel = new EventEmitter();
    @Output() public saveTransformation = new EventEmitter();
    @Input() public switchs: any = {};

    public fieldOperator: string = "";

    public selectedOptions: any = [];
    public options: any = [
        {
            value: "exact",
            label: "Equals value",
        },
        {
            value: "iexact",
            label: "Equals value without case-sensitive",
        },
        {
            value: "exact~",
            label: "Not equals value",
        },
        {
            value: "iexact~",
            label: "Not equals value without case-sensitive",
        },
        {
          value: "nexact",
          label: "Equals normalized value",
        },
        {
          value: "niexact",
          label: "Equals normalized value without case-sensitive",
        },
        {
          value: "nexact~",
          label: "Not equals normalized value",
        },
        {
          value: "niexact~",
          label: "Not equals normalized value without case-sensitive",
        },
        {
            value: "contains",
            label: "Contains value",
        },
        {
            value: "icontains",
            label: "Contains value without case-sensitive",
        },
        {
            value: "in",
            label: "Can be found in",
        },
        {
            value: "defers",
            label: "Not contains value",
        },
        {
            value: "idefers",
            label: "Not contains value without case-sensitive",
        },
        {
            value: "regex",
            label: "Regex expression",
        },
        {
            value: "iregex",
            label: "Regex expression without case-sensitive",
        },
        {
            value: "isnull",
            label: "Nullable",
        },
        {
            value: "isnull~",
            label: "Not nullable",
        },
        {
            value: "lt",
            label: "less than value",
        },
        {
            value: "lte",
            label: "less or equal than value",
        },
        {
            value: "gt",
          label: "greater than value",
        },
      {
        value: "gte",
        label: "greater or equal than value",
      },
      {
        value: "startswith",
        label: "Starts with",
      },
      {
        value: "similarity",
        label: "Similarity",
      },
      {
        value: "nsimilarity",
        label: "Similarity and normalization",
      },
      {
        value: "fuzzy",
        label: "Fuzzy",
      },
      {
        value: "fuzzy_1",
        label: "Fuzzy with precision class 1",
      },
      {
        value: "fuzzy_2",
        label: "Fuzzy with precision class 2",
      },
      {
        value: "fuzzy_3",
        label: "Fuzzy with precision class 3",
      },
      {
        value: "fuzzy_4",
        label: "Fuzzy with precision class 4",
      },
      {
        value: "fuzzy_5",
        label: "Fuzzy with precision class 5",
      },
      {
        value: "fuzzy_6",
        label: "Fuzzy with precision class 6",
      },
      {
        value: "fuzzy_7",
        label: "Fuzzy with precision class 7",
      },
      {
        value: "fuzzy_8",
        label: "Fuzzy with precision class 8",
      },
    ];

    public fieldTypeOptions: any = {
        string: [
          "exact",
          "iexact",
          "exact~",
          "iexact~",
          "nexact",
          "niexact",
          "nexact~",
          "niexact~",
          "contains",
          "icontains",
          "in",
          "defers",
          "idefers",
          "regex",
          "iregex",
          "isnull",
          "isnull~",
          "startswith",
          "similarity",
          "nsimilarity",
          "fuzzy",
          "fuzzy_1",
          "fuzzy_2",
          "fuzzy_3",
          "fuzzy_4",
          "fuzzy_5",
          "fuzzy_6",
          "fuzzy_7",
          "fuzzy_8",
        ],
        number: [
            "exact",
            "exact~",
            "isnull",
            "isnull~",
            "in",
            "lt",
            "lte",
            "gt",
            "gte",
        ],
        catalog: [
            "exact",
            "exact~",
            "in",
        ],
        boolean: [
            "exact",
            "exact~",
            "in",
        ],
        date: [
            "exact",
            "exact~",
            "lt",
            "lte",
            "gt",
            "gte",
            "in",
        ],
        file: [
            "exact",
            "exact~",
        ],
    };

    public ngOnInit() {
        this.initAvailableOptions();
        if (this.switchs.item.field.targetFieldProperties?.fieldOperator) {
            this.fieldOperator = this.switchs.item.field.targetFieldProperties.fieldOperator;
        } else {
            this.fieldOperator = "exact";
        }
        if (this.fieldOperator) {
            // @ts-ignore
            this.transformationProps.fieldOperator = this.fieldOperator;
        }
    }

    public initAvailableOptions() {
        this.selectedOptions = this.options;
        let computedType = "string";
        if (this.switchs.item.field && this.switchs.item.field.field) {
            switch (this.switchs.item.field.field.remoteType.toLowerCase()) {
                case "date":
                case "datetime":
                case "date-time":
                    computedType = "date";
                    break;
                case "numeric":
                case "number":
                case "decimal":
                case "integer":
                    computedType = "number";
                    break;
                case "boolean":
                    computedType = "boolean";
                    break;
                case "document":
                case "fileupload":
                case "file":
                case "requirement":
                case "result":
                    computedType = "file";
                    break;
                case "classification":
                case "catalog":
                    computedType = "catalog";
                    break;
                case "radio":
                    computedType = "radio";
                    break;
                case "checkbox":
                case "selectboxes":
                case "text":
                case "string":
                case "textfield":
                case "mycontent":
                default:
                    computedType = "string";
            }
            console.log(computedType, this.fieldTypeOptions[computedType]);
            this.setAvailableOptions(this.fieldTypeOptions[computedType]);
        }
    }

    public setAvailableOptions(opts) {
        if (opts) {
            this.selectedOptions = [];
            opts.forEach((opt) => {
                const o = this.options.find((v) => opt === v.value );
                console.log(o, opt);
                if (o) {
                    this.selectedOptions.push(o);
                }
            });
        }
    }

    public selectChanged() {
        // @ts-ignore
        this.transformationProps.fieldOperator = this.fieldOperator;
    }
}
